<div class="body promo-video-container">
    <button type="button" class="close-button" mat-icon-button (click)="panelRef.close()">
        <mat-icon svgIcon="close"></mat-icon>
    </button>

    <iframe width="1024" height="576" [src]="videoUrl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
